<template>
    <div class='line' :class="{selectedLine: selectedLine}"  :data-word="dicoObj.name" @click='$emit("selectLine")'  >
        <div class='col col1'>
            <a  @click='showDico(dicoObj.name)'  :title="'Consulter le dictionnaire '+ dicoObj.name">{{ dicoObj.name }}</a>
        </div>
        <div class='col col2'>
            <input type="checkbox" :id="'chk_'+dicoObj.name" :value="dicoObj.name" @click='updateDicoState()'  :checked='dicoObj.installed ? true : null'>
        </div>
        
        <div class='col col3'>
            <button id="btnDelete" class="mdl-button mdl-js-button mdl-button--icon btn_deletesub" :disabled='dicoObj.installed ? true : null' :title="'Supprimer le dictionnaire '+dicoObj.name" :data-dico="dicoObj.name" @click='askDeleteDico(dicoObj.name)'><i class="material-icons">delete</i></button>
        </div>
        <button id="btnExport" class="mdl-button mdl-js-button mdl-button--icon" :title="'Télécharger le dictionnaire '+dicoObj.name" :data-dico="dicoObj.name" @click='downloadDico(dicoObj.name)'><i class="material-icons">file_download</i></button>
    </div> 
</template>

<script>
    import axios from 'axios'
    import FctUtils from '@/components/FctUtils';
    import { diagonalbackURL, defaultConfig, OctetStreamConfig } from "../constantes";

    export default { 
        name:"DicoLine",
        mixins: [FctUtils],
        props:{
            settingObj:{type:Object},
            dicoObj: {type:Object},
            selectedLine:{type:Boolean},
        },
        methods:{
            showDico(aDicoName) {
                this.$router.push({name:"DicoFrame", params: {
                    diconame: aDicoName, 
                    settingObjStr : JSON.stringify(this.settingObj)
                } });
            },
            askDeleteDico() {
                this.emitter.emit('showPLForm', {mode:'formDico_remove', data:this.dicoObj});
            },
            updateDicoState() {
                var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/dictionaries/" + this.dicoObj.name;

                const params = JSON.stringify( {'install' : ""+!this.dicoObj.installed});

                axios.post(url, params, defaultConfig)
                .then(reponse => {
                    this.dicoObj.installed = !this.dicoObj.installed;

                    this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                })
                .catch(error => {
                    var aMsg = 'Echec lors de ';
                    if (!this.dicoObj.installed) {
                        aMsg += 'l\'installation';
                    }
                    else {
                        aMsg += 'la mise en réserve'
                    }
                    aMsg += ' du dictionnaire '+ this.dicoObj.name; 
                    
                    // on remet la checkbox dans le bon état
                    document.getElementById("chk_"+this.dicoObj.name).checked = this.dicoObj.installed;

                    alert(aMsg);
                });
            },
            downloadDico(diconame) {
                var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/dictionaries/" + this.dicoObj.name;

                axios(url, OctetStreamConfig)
                .then(response => {
                    this.downloadFile(diconame, response.data);
                })
                .catch(error => this.errorHandler(error));
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#btnExport {
    position: absolute;
    top: 5px;
    right: 5px;
    color: #0075bb;
}



</style>
